export default function createPromiseMiddleware(lblList) {
  return () => (next) => (action) => {
    const {type} = action;
    if (lblList.includes(type)) {
      return new Promise((resolve, reject) => {
        next({
          _resolve: resolve,
          _reject: reject,
          ...action,
        });
      });
    }
    return next(action);
  };
}
